var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { createUseStyles } from "react-jss";
var elementMap = {
    title: "h1",
    body: "p",
    heading2: "h2",
    heading3: "h3",
    heading4: "h4",
    heading5: "h5",
    heading6: "h6",
};
var useStyles = createUseStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f;
    return ({
        root: {
            lineHeight: 1.1,
            color: function (props) { return props.color || "inherit"; },
        },
        title: (_a = {
                fontSize: theme.typography.title.fontSizeMobile,
                fontWeight: theme.typography.title.fontWeight
            },
            _a[theme.mediaQuery(theme.breakpoints.medium)] = {
                fontSize: theme.typography.title.fontSizeTablet,
            },
            _a),
        heading2: (_b = {
                fontSize: theme.typography.heading2.fontSizeMobile,
                fontWeight: theme.typography.heading2.fontWeight
            },
            _b[theme.mediaQuery(theme.breakpoints.medium)] = {
                fontSize: theme.typography.heading2.fontSizeTablet,
            },
            _b),
        heading3: (_c = {
                fontSize: theme.typography.heading3.fontSizeMobile,
                fontWeight: theme.typography.heading3.fontWeight
            },
            _c[theme.mediaQuery(theme.breakpoints.medium)] = {
                fontSize: theme.typography.heading3.fontSizeTablet,
            },
            _c),
        heading4: (_d = {
                fontSize: theme.typography.heading4.fontSizeMobile,
                fontWeight: theme.typography.heading4.fontWeight
            },
            _d[theme.mediaQuery(theme.breakpoints.medium)] = {
                fontSize: theme.typography.heading4.fontSize,
            },
            _d),
        heading5: (_e = {
                fontSize: theme.typography.heading5.fontSizeMobile,
                fontWeight: theme.typography.heading5.fontWeight
            },
            _e[theme.mediaQuery(theme.breakpoints.medium)] = {
                fontSize: theme.typography.heading5.fontSizeTablet,
            },
            _e),
        heading6: (_f = {
                fontSize: theme.typography.heading6.fontSizeMobile,
                fontWeight: theme.typography.heading6.fontWeight
            },
            _f[theme.mediaQuery(theme.breakpoints.medium)] = {
                fontSize: theme.typography.heading6.fontSizeTablet,
            },
            _f),
        body: {
            fontSize: theme.typography.body.fontSize,
            fontWeight: theme.typography.body.fontWeight,
            marginBottom: "2.5rem",
        },
    });
});
var Typography = function (_a) {
    var children = _a.children, className = _a.className, color = _a.color, elementProp = _a.element, _b = _a.variant, variant = _b === void 0 ? "body" : _b, rest = __rest(_a, ["children", "className", "color", "element", "variant"]);
    var classes = useStyles({ color: color });
    // @ts-ignore
    var Element = elementProp || elementMap[variant] || "span";
    return (React.createElement(Element, __assign({ className: classNames(classes.root, [classes[variant]], className) }, rest), children ? children : null));
};
Typography.defaultProps = {
    variant: "body",
};
Typography.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    element: PropTypes.string,
    variant: PropTypes.oneOf([
        "title",
        "body",
        "heading2",
        "heading3",
        "heading4",
        "heading5",
        "heading6",
    ]),
    dangerouslySetInnerHTML: PropTypes.any,
};
export default Typography;
